import * as qs from '@/ui/queryState';
import { SortDirection } from '@/ui/types';

export const useSorting = (
  defaultField: string,
  defaultDirection: SortDirection,
) => {
  const sort = qs.string('sort', defaultField);
  const dir = qs.stringEnum(
    'dir',
    Object.values(SortDirection),
    defaultDirection,
  );
  const defaultValues = { dir: defaultDirection, sort: defaultField };

  const onSortChange = (field : string, direction: SortDirection): void => {
    if (sort.value === field && dir.value === SortDirection.Descending && sort.value !== defaultValues.sort) {
      sort.value = defaultValues.sort;
      dir.value = defaultValues.dir;
    } else {
      sort.value = field;
      dir.value = direction;
    }
  };

  return {
    sort,
    dir,
    onSortChange,
  };
};
